// extracted by mini-css-extract-plugin
export default {"logout":"icons_logout__OVA0Z","home":"icons_home__-x15O","profile":"icons_profile__Tsmqt","settings":"icons_settings__Kz6GF"};